<template>
  <div>
    <div
      class="modal fade"
      id="modal-form-inspeccion"
      style="background-color: #00000082"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Inspección</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card-body p-0">
              <table
                class="table table-striped table-bordered table-hover table-md"
              >
                <thead class="thead-dark">
                  <tr>
                    <th>Inspeccion</th>
                    <th>Acción</th>
                  </tr>
                </thead>
                <tbody v-if="inspecciones.length > 0">
                  <tr
                    v-for="item of arrayFinal"
                    :key="item.formato_inspeccion_id"
                  >
                    <!-- Mostrar nombre de inspección cuando tiene guía -->
                    <td
                      v-if="
                        viaje.guia_id != null &&
                        item.info_formato.tipo_operacion == 2
                      "
                    >
                      {{ item.info_formato.nombre }} {{ item.info_formato }}
                    </td>
                    <!-- Mostrar nombre de inspección cuando NO tiene guía -->
                    <td
                      v-else-if="
                        viaje.guia_id == null &&
                        item.info_formato.tipo_operacion == 1
                      "
                    >
                      <div>
                        {{ item.info_formato.nombre }}
                      </div>
                      <span
                        v-if="item.formato_inspeccion_id == 47"
                        class="badge"
                        :class="
                          item.formato_inspeccion_id == 47 &&
                          valInspeccionFechasMsgBadge(viaje)
                        "
                      >
                        {{ valInspeccionFechasMsg(viaje) }}
                      </span>
                    </td>
                    <!-- Mostrar nombre cuando no cumple las condiciones anteriores (fallback) -->
                    <td v-else>
                      {{ item.info_formato.nombre }}
                      {{ item.fecha_vencimiento }}
                    </td>
                    <!-- Mostrar inspección existente PRIMERO (cuando item.info no es null) -->
                    <td
                      class="text-center"
                      v-if="item.info != null && item.info.id"
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-default py-0"
                        style="cursor: pointer"
                        @click="edit(item.info.id)"
                      >
                        {{ item.info.id }}
                      </button>
                    </td>
                    <!-- Botón para crear inspección cuando NO existe y tiene guía -->
                    <td
                      class="text-center"
                      v-else-if="
                        item.info == null &&
                        viaje.guia_id != null &&
                        item.info_formato.tipo_operacion == 2 &&
                        puedeInspeccionarDesdeCargue(viaje)
                      "
                    >
                      <button
                        type="button"
                        class="btn btn-info float-lg-right"
                        style="cursor: pointer"
                        @click="inspeccion(viaje, item.info_formato)"
                      >
                        <i class="fas fa-plus-square"></i>
                      </button>
                    </td>
                    <!-- Botón solo para formato 47 cuando el documento está VENCIDO -->
                    <td
                      class="text-center"
                      v-else-if="
                        item.formato_inspeccion_id == 47 &&
                        valInspeccionFechas(viaje)
                      "
                    >
                      <button
                        type="button"
                        class="btn btn-info float-lg-right"
                        style="cursor: pointer"
                        @click="inspeccion(viaje, item.info_formato)"
                      >
                        <i class="fas fa-plus-square"></i>
                      </button>
                    </td>
                    <!-- Botón para otras inspecciones (formato 47 solo en el bloque anterior cuando documento vencido) -->
                    <td
                      class="text-center"
                      v-else-if="
                        item.formato_inspeccion_id != 47 &&
                        item.info == null &&
                        viaje.inspecciones.length == 0 &&
                        item.info_formato.tipo_operacion == 1 &&
                        puedeInspeccionarDesdeCargue(viaje)
                      "
                    >
                      <!-- Botón para otras inspecciones (formato 47 solo en el bloque anterior cuando documento vencido) -->
                      <button
                        v-if="item.formato_inspeccion_id != 44"
                        type="button"
                        class="btn btn-info float-lg-right"
                        style="cursor: pointer"
                        @click="inspeccion(viaje, item.info_formato)"
                      >
                        <i class="fas fa-plus-square"></i>
                      </button>
                      <!-- Botón para inspección preoperacional (formato 44) -->
                      <button
                        v-if="
                          item.formato_inspeccion_id == 44 &&
                          permiteInspeccionPreoperacional(viaje)
                        "
                        type="button"
                        class="btn btn-info float-lg-right"
                        style="cursor: pointer"
                        @click="inspeccion(viaje, item.info_formato)"
                      >
                        <i class="fas fa-plus-square"></i>
                      </button>
                    </td>
                    <!-- Celda vacía cuando no cumple ninguna condición -->
                    <td v-else class="text-center"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "PlantVentanaOperacionesInspeccion",
  components: {},
  data() {
    return {
      inspecciones: {},
      viajeInspecciones: {},
      totalInspecciones: [],
      arrayFinal: [],
      viaje_id: null,
      viaje: null,
      accion: "",
      metodo: "",
      tipo: null,
    };
  },
  methods: {
    puedeInspeccionarDesdeCargue(viaje) {
      // Obtener el tipo de sitio actual (1 = Sitio, 2 = PuntoGestion)
      const sitioType = this.$parent?.filtros?.sitio_type;
      const sitioActual = this.$parent?.filtros?.sitio_id;

      if (!viaje.det_solicitud_diaria) {
        // 1. Si está en punto de enturne (PuntoGestion), permitir siempre
        if (sitioType == 2 || sitioType == "App\\PuntoGestion") {
          return true;
        }

        // 2. Si está en sitio de cargue (Sitio), verificar si es el sitio de cargue del viaje
        if (sitioType == 1 || sitioType == "App\\Sitio") {
          const sitioCargueViaje =
            viaje?.sitio_cargue_id || viaje?.sitio_cargue?.id;

          // Si está en el sitio de cargue del viaje, permitir siempre
          if (
            sitioActual &&
            sitioCargueViaje &&
            sitioCargueViaje == sitioActual
          ) {
            return true;
          }
        }

        // 3. Si no está en punto de enturne ni en sitio de cargue,
        // aplicar validación de 2 horas después de salir del sitio de cargue
        const fechaSalidaCargue =
          viaje?.trazas_fechas_viaje?.fecha_salida_cargue ||
          viaje?.trazasFechasViaje?.fecha_salida_cargue;

        // Si no hay fecha de salida del sitio de cargue, no se puede inspeccionar
        if (!fechaSalidaCargue) {
          return false;
        }

        // Validar que esté dentro de las 4 horas después de salir del sitio de cargue
        const salida = this.parsearFechaHora(fechaSalidaCargue);
        if (!salida) {
          return false;
        }

        const ahora = new Date();
        const diffMs = ahora.getTime() - salida.getTime();
        const dosHorasMs = 4 * 60 * 60 * 1000;

        // Permitir inspección si han pasado entre 0 y 4 horas desde la salida del sitio de cargue
        return diffMs >= 0 && diffMs <= dosHorasMs;
      }
      return true;
    },

    parsearFechaHora(valor) {
      if (!valor) return null;
      if (valor instanceof Date) return valor;
      if (typeof valor !== "string") return null;

      const normalizado = valor.includes("T") ? valor : valor.replace(" ", "T");
      const fecha = new Date(normalizado);
      if (!Number.isNaN(fecha.getTime())) {
        return fecha;
      }

      const partes = valor.split(" ");
      if (partes.length !== 2) return null;
      const [fechaParte, horaParte] = partes;
      const [anio, mes, dia] = fechaParte.split("-").map(Number);
      const [hora, minuto, segundo] = horaParte.split(":").map(Number);
      if (!anio || !mes || !dia || hora === undefined || minuto === undefined) {
        return null;
      }
      return new Date(anio, mes - 1, dia, hora, minuto, segundo || 0);
    },

    async cargarInspecciones() {
      let me = this;
      await axios
        .get(
          "/api/plant/ventanasEnturnamientoOperacion/cargarInspeccion?viaje_id=" +
            this.viaje_id +
            "&tipo=" +
            this.tipo
        )
        .then(async (response) => {
          me.$parent.cargando = false;
          let res = response.data;

          if (res.Msg == "error") {
            //this.$refs.closeModal.click();
            if (res.errors.vehiculo.error !== undefined) {
              await this.$parent.msgDocumentacion(
                res.errors.vehiculo,
                "Vehiculo"
              );
            }
            if (res.errors.remolque.error !== undefined) {
              await this.$parent.msgDocumentacion(
                res.errors.remolque,
                "Remolque"
              );
            }
            if (res.errors.conductor.error !== undefined) {
              await this.$parent.msgDocumentacion(
                res.errors.conductor,
                "Conductor"
              );
            }
            // Aunque haya error de documentación, intentar cargar inspecciones si existen
            if (res.data && Array.isArray(res.data)) {
              me.totalInspecciones = res.data;
            } else {
              me.totalInspecciones = [];
            }
          } else if (res.Msg == "Ok") {
            // Asegurarse de que totalInspecciones sea un array
            me.totalInspecciones = Array.isArray(res.data) ? res.data : [];
            me.viajeInspecciones =
              res.data && res.data.length > 0 ? res.data[0] : null;
          } else {
            // Si no hay Msg, asumir que data contiene las inspecciones
            me.totalInspecciones = Array.isArray(res.data) ? res.data : [];
            me.viajeInspecciones =
              res.data && res.data.length > 0 ? res.data[0] : null;
          }

          me.arrayFinal = [];
          await this.cruceInspeccion();
        })
        .catch((error) => {
          me.$parent.cargando = false;
          me.totalInspecciones = [];
          me.arrayFinal = [];
        });
    },

    async cruceInspeccion() {
      this.arrayFinal = [];
      if (
        !this.inspecciones ||
        !this.inspecciones[0] ||
        !this.inspecciones[0].inspecciones
      ) {
        return;
      }

      this.inspecciones[0].inspecciones.forEach((element) => {
        let cruce = {
          formato_inspeccion_id: element.pivot.formato_inspeccion_id,
          info_formato: element,
          info: null,
        };

        // Buscar la inspección existente que coincida con el formato
        if (this.totalInspecciones && this.totalInspecciones.length > 0) {
          for (let i = 0; i < this.totalInspecciones.length; i++) {
            const inspeccion = this.totalInspecciones[i];
            // Comparar formato_inspeccion_id (puede ser string o number)
            const formatoIdElement = element.pivot.formato_inspeccion_id;
            const formatoIdInspeccion = inspeccion?.formato_inspeccion_id;

            if (
              inspeccion &&
              formatoIdInspeccion !== undefined &&
              formatoIdInspeccion !== null &&
              (String(formatoIdInspeccion) === String(formatoIdElement) ||
                formatoIdInspeccion == formatoIdElement)
            ) {
              cruce.info = inspeccion;
              break; // Salir del loop una vez encontrado
            }
          }
        }

        let copyCruce = { ...cruce };
        this.arrayFinal.push(copyCruce);
      });
    },

    async getInspecciones() {
      let me = this;
      me.$parent.cargando = true;
      await axios
        .get(
          "/api/hidrocarburos/ventanasEnturnamientoOperacion/inspeccionViaje?sitio_type=" +
            this.$parent.filtros.sitio_type +
            "&sitio_id=" +
            this.$parent.filtros.sitio_id
        )
        .then((response) => {
          me.inspecciones = response.data;
        });
    },

    // edit() {
    //   var inspeccion = this.viajeInspecciones.id;
    //   alert(inspeccion);
    //   this.$refs.closeModal.click();
    //   return this.$router.push({
    //     name: "/Hidrocarburos/InspeccionForm",
    //     params: { inspeccion_id: inspeccion.id },
    //   });
    // },

    inspeccion(viaje, inspeccion) {
      this.$refs.closeModal.click();
      return this.$router.push({
        name: "/Hidrocarburos/InspeccionForm",
        params: {
          viaje: viaje,
          inspeccion: inspeccion,
          sitio_type: this.$parent.filtros.sitio_type,
          sitio: this.$parent.slct_sitio,
          val: 0,
        },
      });
    },

    inspeccionPreoperacional(viaje) {
      this.$refs.closeModal.click();
      return this.$router.push({
        name: "/Hidrocarburos/InspeccionForm",
        params: {
          viaje: viaje,
          sitio_type: this.$parent.filtros.sitio_type,
          sitio: this.$parent.slct_sitio,
          val: 0,
        },
      });
    },

    async llenar_modal_inspeccion(viaje, tipo) {
      this.viaje_id = viaje.id;
      this.viaje = viaje;
      this.tipo = tipo;
      await this.getInspecciones();
      await this.cargarInspecciones();

      // Si el viaje ya tiene inspecciones cargadas y totalInspecciones está vacío, usarlas
      if (
        viaje.inspecciones &&
        Array.isArray(viaje.inspecciones) &&
        viaje.inspecciones.length > 0
      ) {
        if (this.totalInspecciones.length === 0) {
          this.totalInspecciones = viaje.inspecciones;
          await this.cruceInspeccion();
        }
      }
    },

    edit(inspeccion_id) {
      this.$refs.closeModal.click();
      return this.$router.push({
        name: "/Hidrocarburos/InspeccionForm",
        params: {
          inspeccion_id: inspeccion_id,
        },
      });
    },

    valInspeccionFechas(viaje) {
      const vehiculo = viaje?.vehiculo;
      const ultima = vehiculo?.ultima_inspeccion_vehiculo;
      let val = false;
      if (!vehiculo) return false;

      // Si NO tiene última inspección pero tiene documento vigente → solo mostrar fecha del documento
      if (ultima) {
        if (ultima?.fecha_vencimiento) {
          const vencimiento = new Date(ultima.fecha_vencimiento);
          const hoy = new Date();
          if (hoy > vencimiento) {
            val = true;
          } else {
            val = false;
          }
        } else {
          val = false;
        }
      } else {
        val = true;
      }
      return val;
    },

    valInspeccionFechasMsg(viaje) {
      const vehiculo = viaje?.vehiculo;
      const ultima = vehiculo?.ultima_inspeccion_vehiculo;
      let msg = "";

      if (!vehiculo) return msg;

      //Si tiene última inspección y tiene fecha de vencimiento
      if (ultima) {
        if (ultima.fecha_vencimiento) {
          const vencimiento = new Date(ultima.fecha_vencimiento);
          const hoy = new Date();
          msg =
            hoy > vencimiento
              ? "Inspección vencida: " + ultima.fecha_vencimiento
              : "Fecha vencimiento inspección: " + ultima.fecha_vencimiento;
        } else {
          msg = "Inspección sin fecha de vencimiento";
        }
      } else {
        // Si no tiene última inspección → permitir crear
        msg = "Sin inspección";
      }

      return msg;
    },

    /**
     * Lógica pura (sin mutar estado del componente). Mutar `data` desde métodos
     * llamados en plantilla (:class, {{ }}) provoca re-renders en cadena y puede
     * disparar bucles o "Maximum update depth exceeded".
     */
    estadoInspeccionVehiculoBadge(viaje) {
      const vehiculo = viaje?.vehiculo;
      const ultima = vehiculo?.ultima_inspeccion_vehiculo;
      let bg = "";
      let puedePreoperacional = true;

      if (!vehiculo) {
        return { bg, puedePreoperacional };
      }
      if (ultima) {
        if (ultima.fecha_vencimiento) {
          const vencimiento = new Date(ultima.fecha_vencimiento);
          const hoy = new Date();

          //Si la fecha de vencimiento es menor a hoy, es vencida
          bg = hoy > vencimiento ? "bg-danger" : "bg-success";
          puedePreoperacional = hoy > vencimiento ? false : true;
        } else {
          bg = "bg-danger";
          puedePreoperacional = false;
        }
      } else {
        bg = "bg-danger";
        puedePreoperacional = false;
      }

      return { bg, puedePreoperacional };
    },

    valInspeccionFechasMsgBadge(viaje) {
      return this.estadoInspeccionVehiculoBadge(viaje).bg;
    },

    permiteInspeccionPreoperacional(viaje) {
      return this.estadoInspeccionVehiculoBadge(viaje).puedePreoperacional;
    },
  },
  mounted() {},
};
</script>
